<div class="price-info">
  <h6 class="price-info-headline">
    {{ 'booking.overview.priceModel' | transloco }}
  </h6>
  <h6 class="price-info-headline right-column">
    {{ 'booking.overview.price' | transloco }}
  </h6>
  <div class="price-info-row">
    {{ 'cartridge.priceModel.' + price.priceModel | transloco }}
    {{ 'cartridge.billingPeriod.' + price.billingPeriod | transloco }}
  </div>
  <div class="price-info-row right-column">
    {{
      price.centAmount / 100 | translocoCurrency: 'symbol' : {} : price.currency
    }}
  </div>
  <div></div>
  <div class="vat-hint right-column">
    {{ 'cartridge.priceExcludingVAT' | transloco }}
  </div>
  @if (showSetUpCost) {
    <h6 class="price-info-headline">
      {{ 'cartridge.plusSetUpCosts' | transloco }}
    </h6>
    <div class="price-info-row right-column">
      {{ 'upgrade.summary.variantComparison.notCharged' | transloco }}
    </div>
  }
</div>
